module.exports = __webpack_public_path__ + "nc_static/media/minus.97b238a2.svg";